import { ref, watch, onUnmounted, unref, getCurrentScope } from 'vue';
import { getStockKlineChannelSubscriber } from '@/utils/realtime/stockChannels/stockKlineChannel';

let consumerSeq = 0;

/**
 * 订阅 `stock_kline` 推送，用于更新图表最后一根 K 线。
 *
 * @param {import('vue').MaybeRefOrGetter<{
 *   fullCode: string,
 *   timeIndex: string,
 *   candlePeriod: number,
 *   candleMode: number
 * }|null|undefined>} paramRef 上行 param；为 null 时不订阅
 * @param {{ onPayload?: (payload: object) => void }} [options]
 * @returns {{ klinePayload: import('vue').Ref<object|null> }}
 */
export function useStockKlineRealtime(paramRef, options = {}) {
  const { onPayload } = options;
  const klinePayload = ref(null);
  const consumerId = Symbol(`stock-kline-${++consumerSeq}`);
  const scope = getCurrentScope();

  const subscriber = getStockKlineChannelSubscriber();

  const handlePush = (payload) => {
    if (!payload) {
      return;
    }
    klinePayload.value = payload;
    onPayload?.(payload);
  };

  subscriber.addPushListener(consumerId, handlePush);

  const syncSubscribe = () => {
    const param = unref(paramRef);
    if (!param?.fullCode || !param?.timeIndex) {
      subscriber.unsubscribe(consumerId);
      klinePayload.value = null;
      return;
    }
    subscriber.subscribe(consumerId, param);
  };

  watch(() => unref(paramRef), syncSubscribe, { deep: true, immediate: true });

  if (scope) {
    onUnmounted(() => {
      subscriber.removePushListener(handlePush);
      subscriber.unsubscribe(consumerId);
    });
  }

  return { klinePayload };
}
